import { HttpParameterCodec } from '@angular/common/http';

export { IMenuOption } from './i-menu-option';
export { IPermission } from './i-permission';
export { IRole } from './i-role';
export { IUser } from './i-user';

export class CustomURLEncoder implements HttpParameterCodec {
    encodeKey(key: string): string {
        return encodeURIComponent(key); 
    }
    encodeValue(key: string): string { 
        return encodeURIComponent(key); 
    }
    decodeKey(key: string): string { 
        return decodeURIComponent(key); 
     }
    decodeValue(key: string) {
        return decodeURIComponent(key); 
     }
} 